import { i18n } from '@/i18n'

// ! Uses enums from server

export default {
  project: {
    name: i18n.t('addon:project'),
    description: 'Opprett et nytt prosjekt og velg hvilke moduler du ønsker på prosjektet.',
    icon: 'drafting-compass',
    link: '',
  },
  'project:presentation': {
    name: i18n.t('addon:project:presentation'),
    description: 'Lanser prosjektsider med boligvelgere enkelt og raskt.',
    icon: 'browser',
    link: 'https://www.kvass.no/presentasjon',
  },
  'project:flatfinder': {
    name: i18n.t('addon:flatfinder'),
    description: 'Lanser boligsider med boligvelgere enkelt og raskt.',
    icon: 'layer-plus',
  },
  'project:bid': {
    name: i18n.t('addon:project:bid'),
    description: 'Selg enkelt & digitalt via prosjekt-/boligsiden.',
    condition: '(Inkl. inntil 200 signeringer / år - utover det: kr 25 pr. signatur)',
    icon: 'file-contract',
    link: 'https://www.kvass.no/salg',
  },
  'project:purchase': {
    name: i18n.t('addon:project:purchase'),
    description: 'Send ut og signer kjøpekontrakt digitalt.',
    condition: '(Inkl. inntil 200 signeringer / år - utover det: kr 25 pr. signatur)',
    icon: 'file-contract',
    link: 'https://www.kvass.no/salg',
  },
  'project:shop': {
    name: i18n.t('addon:project:shop'),
    description: 'Presenter tilvalg digitalt via prosjekt- / boligsiden eller via link.',
    icon: 'file-contract',
    link: 'https://www.kvass.no/tilvalg',
  },
  'project:shop-purchase': {
    name: i18n.t('addonShopPurchase'),
    description: 'Selg og signer tilvalg digitalt.',
    condition: '(Inkl. inntil 200 signeringer / år - utover det: kr 25 pr. signatur)',
    icon: 'file-contract',
    link: 'https://www.kvass.no/tilvalg',
  },
  'project:complaint': {
    name: i18n.t('addon:project:complaint'),
    description: 'La dine kunder sende inn reklamasjoner og henvendelser på en brukervennlig måte.',
    icon: 'home',
    link: '',
  },
  'custom-contract': {
    name: i18n.t('addon:custom-contract'),
    description: 'Signer dokumenter digitalt',
    condition: '(Inkl. inntil 200 signeringer / år - utover det: kr 25 pr. signatur)',
    icon: 'file-contract',
    // link: 'https://www.kvass.no/tilvalg',
  },
  api: {
    name: i18n.t('addon:api'),
    description: 'Få tilgang til API og Webhook integrasjoner',
    icon: 'brackets-curly',
  },
  'project:integration-fonn': {
    name: 'Fonn',
    description: 'Fonn er et brukervennlig og effektivt prosjektstyringsverktøy for små og store byggeprosjekter.',
    icon: 'brackets-curly',
  },
  page: {
    name: i18n.t('addon:page'),
    description: 'Opprett en ny side',
    icon: 'browser',
    link: '',
  },
}
